export const defaultService = {
  nameFr: "",
  nameEn: "",
  descriptionFr: "",
  descriptionEn: "",
  category: "",
  imageUrl: "",
  price: "",
  priceTypeId: 0,
  isVisible: false,
  serviceNumber: "",
  location: {
    formattedAddress: "",
    latitude: 0,
    longitude: 0,
    regionId: 0,
  },
  availabilities: [],
  showAddress: true,
  productInventoryLimits: {
    inventoryMode: "unlimited",
    totalQuantity: 0,
    maxDuration: 0,
    returnMode: "none",
    returnPolicy: "",
  },
};
